import store from '../store'

const UuidKey = 'uuid'
const RefKey = 'ref_user'
const RefTmpKey = 'ref_tmp_user'
const ApiKey = 'api'

const RefMeetingKey = 'ref_meeting'

const PopupViewKey = 'popup'

const SmsCountKey = 'sms_count'

const ExpoConfigKey = 'expo_config'

const FormRecordQueryKey = 'form_record_query'

export function getApiUrl() {
  return localStorage.getItem(ApiKey)
}

export function getExpoConfig() {
  const val = localStorage.getItem(ExpoConfigKey)
  const dataObj = JSON.parse(val)
  if (dataObj) {
    return dataObj
  } else {
    return null
  }
}

export function setExpoConfig(config) {
  localStorage.setItem(ExpoConfigKey, JSON.stringify(config))
}

export function setFormRecordQuery(query) {
  localStorage.setItem(FormRecordQueryKey, JSON.stringify(query))
}

export function getFormRecordQuery() {
  const val = localStorage.getItem(FormRecordQueryKey)
  const dataObj = JSON.parse(val)
  if (dataObj) {
    return dataObj
  } else {
    return null
  }
}

export function setUuid(uuid) {
  const currTime = new Date().getTime()
  localStorage.setItem(UuidKey,
    JSON.stringify({ uuid: uuid, time: currTime }))
}

export function getUuid() {
  const val = localStorage.getItem(UuidKey)
  const dataObj = JSON.parse(val)
  if (dataObj) {
    return dataObj.uuid
  } else {
    return null
  }
}

export function setRef(ref) {
  const currTime = new Date().getTime()
  const val = localStorage.getItem(RefKey)
  var dataObj = JSON.parse(val)
  if (dataObj) {
    dataObj['user_id'] = ref
    dataObj['user_time'] = currTime
  } else {
    dataObj = { user_id: ref, user_time: currTime }
  }
  localStorage.setItem(RefKey, JSON.stringify(dataObj))
}

export function setRefTmp(ref) {
  const currTime = new Date().getTime()
  const val = localStorage.getItem(RefTmpKey)
  var dataObj = JSON.parse(val)
  if (dataObj) {
    dataObj['user_id'] = ref
    dataObj['user_time'] = currTime
  } else {
    dataObj = { user_id: ref, user_time: currTime }
  }
  localStorage.setItem(RefTmpKey, JSON.stringify(dataObj))
}

export function getRef() {
  const val = localStorage.getItem(RefKey)
  const dataObj = JSON.parse(val)
  if (dataObj) {
    return dataObj
  } else {
    const tmp = localStorage.getItem(RefTmpKey)
    const tmpObj = JSON.parse(tmp)
    if (tmpObj && store.getters.user && store.getters.user.id !==
      tmpObj.user_id) {
      localStorage.setItem(RefKey, tmp)
    } else {
      return null
    }
  }
}

export function setRefMeeting(ref) {
  const currTime = new Date().getTime()
  const val = localStorage.getItem(RefMeetingKey)
  var dataObj = JSON.parse(val)
  if (dataObj) {
    dataObj['user_id'] = ref
    dataObj['user_time'] = currTime
  } else {
    dataObj = { user_id: ref, user_time: currTime }
  }
  localStorage.setItem(RefMeetingKey, JSON.stringify(dataObj))
}

export function getRefMeeting() {
  const val = localStorage.getItem(RefMeetingKey)
  const dataObj = JSON.parse(val)
  if (dataObj) {
    return dataObj.user_id
  } else {
    return null
  }
}

export function getPopupList() {
  const val = localStorage.getItem(PopupViewKey)
  const dataObj = JSON.parse(val)
  const uuid = getUuid()
  if (dataObj && dataObj[uuid]) {
    return dataObj[uuid]
  } else {
    return []
  }
}

export function setPopupList(list) {
  const val = localStorage.getItem(PopupViewKey)
  const dataObj = val ? JSON.parse(val) : {}
  const uuid = getUuid()
  dataObj[uuid] = list
  localStorage.setItem(PopupViewKey, JSON.stringify(dataObj))
}

export function getSmsCount() {
  const val = localStorage.getItem(SmsCountKey)
  if (val) {
    try {
      return parseInt(val)
    } catch (e) {
      return 0
    }
  } else {
    return 0
  }
}

export function setSmsCount(smsCount) {
  localStorage.setItem(SmsCountKey, smsCount)
}



// WEBPACK FOOTER //
// ./src/utils/storage.js